import { render, staticRenderFns } from "./realtime_guardwitness_list.vue?vue&type=template&id=6c0ee79e&scoped=true"
import script from "./realtime_guardwitness_list.vue?vue&type=script&lang=js"
export * from "./realtime_guardwitness_list.vue?vue&type=script&lang=js"
import style0 from "./realtime_guardwitness_list.vue?vue&type=style&index=0&id=6c0ee79e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ee79e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0ee79e')) {
      api.createRecord('6c0ee79e', component.options)
    } else {
      api.reload('6c0ee79e', component.options)
    }
    module.hot.accept("./realtime_guardwitness_list.vue?vue&type=template&id=6c0ee79e&scoped=true", function () {
      api.rerender('6c0ee79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/guardWitness/realtime_guardwitness_list.vue"
export default component.exports